import React, { useState } from 'react';

import CompanyLogo from '../../assets/company-logo.png';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../firebase';
import Version from '../../version';

const ForgotPassword = ({ close }) => {
  const [recoverError, setRecoverError] = useState();
  const [showSuccess, setShowSuccess] = useState(false);
  const [email, setEmail] = useState('');

  const recover = async e => {
    e.preventDefault();
    sendPasswordResetEmail(auth, email)
      .then(() => setShowSuccess(true))
      .catch(error => setRecoverError(error));
  };

  return (
    <>
      {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-50">
        <body class="h-full">
        ```
      */}
      <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <img className="mx-auto h-12 w-auto mb-6" src={CompanyLogo} alt="" />
          <h2 className="mt-8 text-center text-3xl font-extrabold text-gray-900">
            Reset Your Password
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            We will email you a password reset link if your email is registered
            with us.
          </p>
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            {recoverError && (
              <div className="text-red-700 mb-2">{recoverError.message}</div>
            )}
            {showSuccess && (
              <div>
                <div className="text-green text-sm text-center mb-4">
                  Please check your email and your Spam folder.
                </div>
                <div className="mt-2">
                  <button
                    type="submit"
                    onClick={close}
                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-button-text bg-button-bg hover:bg-button-bg-hover hover:text-button-text-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    Back to Login
                  </button>
                </div>
              </div>
            )}
            {!showSuccess && (
              <form className="space-y-6" action="#" method="POST">
                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm font-medium text-gray-700">
                    Email address
                  </label>
                  <div className="mt-1">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      onChange={e => setEmail(e.target.value)}
                      autoComplete="email"
                      required
                      className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    />
                  </div>
                </div>
                <div>
                  <div className="text-sm">
                    <a
                      href="#"
                      onClick={close}
                      className="font-medium text-activecourse-blue hover:text-activecourse-orange">
                      Back to Login?
                    </a>
                  </div>
                </div>

                <div>
                  <button
                    type="submit"
                    onClick={e => recover(e)}
                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-button-text bg-button-bg hover:bg-button-bg-hover hover:text-button-text-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    Send Password Reset Email
                  </button>
                </div>
              </form>
            )}
            <Version />
          </div>
        </div>
      </div>
    </>
  );
};
export default ForgotPassword;
